<template>
  <div id="app">
    <Cmessage v-if="showModal" :text="errorMessage" @closeModal="showModal = false" />
    <router-view/>
  </div>
</template>

<script>
import Cmessage from './components/c-message.vue'
import { EventBus } from './request/eventBus';
export default {
  name: 'App',
  components: {
    Cmessage
  },
   data() {
    return{
      showModal: false,
      errorMessage: ''
    }
   },
   created() {
    EventBus.$on('showErrorModal', this.showErrorModal);
  },
  beforeDestroy() {
    EventBus.$off('showErrorModal', this.showErrorModal);
  },
  methods: {
    showErrorModal(message) {
      this.errorMessage = message;
      this.showModal = true;
    }
  }
}
</script>
 
<style lang="less">
@import "./common.less";
#app{
  max-width: 500px;
  margin: 0% auto;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue